import { User } from "@supabase/supabase-js"
import { useUser } from "@/contexts/AuthContext"

/**
 * Hook that returns the logged-in user or throws an error if not authenticated.
 * This is useful for pages that require the user to be logged in.
 *
 * Migrated from @supabase/auth-helpers-react to @supabase/ssr
 * @returns The logged in user or throws an error if the user is not logged in
 */
export const useLoggedInUser = (): User => {
    const user = useUser()
    if (!user) {
        throw new Error("User is not logged in")
    }
    return user
}
